import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconInspectorS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.42417 1.09883C6.15538 0.972913 5.84453 0.972916 5.57574 1.09884L1.22329 3.13785C0.916208 3.28171 0.916212 3.71844 1.2233 3.8623L5.66073 5.94101C5.87577 6.04174 6.12444 6.04174 6.33947 5.94101L10.7769 3.86231C11.084 3.71845 11.084 3.28171 10.7769 3.13785L6.42417 1.09883Z"
        fill="#0078D2"
      />
      <path
        d="M2.05113 5.25L1.22323 5.63785C0.916147 5.78171 0.916151 6.21844 1.22324 6.3623L5.66067 8.44101C5.8757 8.54174 6.12438 8.54174 6.33941 8.44101L10.7768 6.36231C11.0839 6.21845 11.0839 5.78171 10.7768 5.63785L9.94897 5.25005L6.33947 6.94091C6.12444 7.04165 5.87577 7.04165 5.66073 6.94091L2.05113 5.25Z"
        fill="#0078D2"
      />
      <path
        d="M2.05113 7.74996L1.22323 8.13781C0.916147 8.28167 0.916151 8.7184 1.22324 8.86225L5.66067 10.941C5.8757 11.0417 6.12438 11.0417 6.33941 10.941L10.7768 8.86226C11.0839 8.71841 11.0839 8.28167 10.7768 8.13781L9.94897 7.75001L6.33947 9.44087C6.12444 9.5416 5.87577 9.5416 5.66073 9.44087L2.05113 7.74996Z"
        fill="#0078D2"
      />
    </svg>
  )
}

export const IconInspector = createIcon({
  l: IconInspectorS,
  m: IconInspectorS,
  s: IconInspectorS,
  xs: IconInspectorS,
  name: 'IconInspector',
})
